const SupplierId = {
  'PRD': [
    { displayName: '2725 - Produce', name: 'Produce', supplierId: '2725' },
    { displayName: '8600 - Produce', name: 'Produce', supplierId: '8600' },
  ],
  'WHD': [
    { displayName: '28213 - Colne', name: 'Colne', supplierId: '28213' },
    { displayName: '24110 - Turiff', name: 'Turiff', supplierId: '24110' },
    { displayName: '34516 - Spalding', name: 'Spalding', supplierId: '34516' }
  ],
  'RBL': [
    { displayName: '2745 - Wakefield', name: 'Wakefield', supplierId: '2745' },
    { displayName: '2868 - Wakefield', name: 'Wakefield', supplierId: '2868' },
  ],
  'ISL': [
    { displayName: '24518 - Lakeside', name: 'Lakeside', supplierId: '24518' },
    { displayName: '6994 - Lakeside', name: 'Lakeside', supplierId: '6994' },
  ],
  'SFL': [
    { displayName: '15346 - Worsley', name: 'Worsley', supplierId: '15346' },
    { displayName: '1217 - Worsley', name: 'Worsley', supplierId: '1217' },
  ],
  'FBG': [
    { displayName: 'All Greenside Supplier Ids', name: 'Greenside', supplierId: '2639,2645,24305,8803,8807,8800' },
  ],
  'FBD': [
    { displayName: 'All Deeside Supplier Ids', name: 'Deeside', supplierId: '15318,8811' },
  ],
  'FBW': [
    { displayName: 'All Winsford Supplier Ids', name: 'Winsford', supplierId: '23028,0253' },
  ],
  'LLN': [
    { displayName: '23979 - Lowlands', name: 'Lowlands', supplierId: '23979' },
    { displayName: '1208 - Lowlands', name: 'Lowlands', supplierId: '1208' },
  ],
  'FLW': [
    { displayName: '23974 - Flowerworld', name: 'Flowerworld', supplierId: '23974' },
    { displayName: '0636 - Flowerworld', name: 'Flowerworld', supplierId: '0636' },
  ],
};

export default SupplierId;